import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Popover,
  CardHeader,
  Divider,
  colors
} from '@material-ui/core';

import { List, EmptyList } from './components';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: '100%'
  },
  actions: {
    backgroundColor: colors.grey[50],
    justifyContent: 'center'
  }
}));

const AccessibilityPopover = props => {
  const { items, anchorEl, ...rest } = props;

  const classes = useStyles();

  return (
    <Popover
      {...rest}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
    >
      <div className={classes.root}>
        <CardHeader title="Accessibility" />
        <Divider />
        {items.length > 0 ? (
          <List items={items} />
        ) : (
          <EmptyList />
        )}
      </div>
    </Popover>
  );
};

AccessibilityPopover.propTypes = {
  anchorEl: PropTypes.any,
  className: PropTypes.string,
  items: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default AccessibilityPopover;
